export enum CssPositionEnum {
  FIXED = 'fixed',
  RELATIVE = 'relative',
  ABSOLUTE = 'absolute',
  UNSET = 'unset',
  INHERIT = 'inherit',
}
